import React from "react";
import { usePageSeo } from "../../shared/seo";

const PrivacyPolicy = () => {
  usePageSeo("privacyPolicy");

  return (
    <section className="section py-40 py-sm-60">
      <div className="container container-lg">
        <div className="text-center mb-32 mb-sm-40">
          <h2 className="fw-bold text-main-700 mb-8">Privacy Policy</h2>
          <p className="text-neutral-600 mb-0">Last Updated: August 2026</p>
        </div>

        <div className="mx-auto" style={{ maxWidth: "860px" }}>
          <div className="rounded-12 bg-white border border-main-100 p-24 p-sm-32" style={{ boxShadow: "0 2px 8px rgba(26, 107, 48, 0.05)" }}>
            <p className="text-neutral-700 mb-16">
              Fugu's ("we", "us", or "our") respects your privacy and is
              committed to protecting the personal information you share with
              us. This Privacy Policy explains how we collect, use, disclose,
              and safeguard your information when you visit our website or
              place an order with us.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">1. Information We Collect</h5>
            <ul className="mb-16 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                <strong>Personal Information:</strong> Name, email address,
                phone number, delivery address, and payment details provided
                during account creation or checkout.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                <strong>Order Information:</strong> Products you purchase,
                order history, preferences, and delivery instructions.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                <strong>Usage Information:</strong> Browser type, device
                information, pages visited, and cookies used to improve your
                shopping experience.
              </li>
            </ul>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">2. How We Use Your Information</h5>
            <ul className="mb-16 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                To process and deliver your orders, including order updates
                and notifications.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                To manage your account, wishlist, and saved addresses.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                To provide customer support and respond to your inquiries.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                To send promotional offers, deals, and newsletters with your
                consent.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                To improve our website, products, and services.
              </li>
            </ul>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">3. How We Share Your Information</h5>
            <p className="text-neutral-700 mb-16">
              We do not sell your personal information. We may share your data
              with trusted service providers such as delivery partners,
              payment gateways, and analytics providers solely to fulfil your
              orders and improve our services.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">4. Data Security</h5>
            <p className="text-neutral-700 mb-16">
              We implement appropriate technical and organisational measures to
              protect your personal information against unauthorised access,
              alteration, disclosure, or destruction. However, no method of
              transmission over the internet is 100% secure.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">5. Cookies</h5>
            <p className="text-neutral-700 mb-16">
              We use cookies and similar technologies to enhance your browsing
              experience, remember your preferences, and understand how you
              interact with our website. You can control cookies through your
              browser settings.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">6. Your Rights</h5>
            <p className="text-neutral-700 mb-16">
              You may access, update, or delete your personal information at
              any time through your account settings. You may also request
              that we stop sending you promotional communications at any time.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">7. Children's Privacy</h5>
            <p className="text-neutral-700 mb-16">
              Our services are not directed to individuals under 18 years of
              age. We do not knowingly collect personal information from
              children.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">8. Changes to This Policy</h5>
            <p className="text-neutral-700 mb-16">
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated revision date. We
              encourage you to review this policy periodically.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">9. Contact Us</h5>
            <p className="text-neutral-700 mb-0">
              If you have any questions or concerns about this Privacy Policy,
              please contact us at{" "}
              <a href="mailto:info@fishhub.com" className="text-main-600 text-decoration-none">
                info@fishhub.com
              </a>{" "}
              or write to us at Ground Floor, Ward No. 16, Door No 446B, 446 C,
              FUGUS BUILDING, Elbo Road, Puthuvype, Ernakulam, Kerala - 682508.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
